/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_MmkvInputs */

const en_svchip_mmkv = /** @type {(inputs: Svchip_MmkvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MMKV`)
};

const ar_svchip_mmkv = /** @type {(inputs: Svchip_MmkvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MMKV`)
};

const bn_svchip_mmkv = /** @type {(inputs: Svchip_MmkvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MMKV`)
};

const de_svchip_mmkv = /** @type {(inputs: Svchip_MmkvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MMKV`)
};

const es_svchip_mmkv = /** @type {(inputs: Svchip_MmkvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MMKV`)
};

const fr_svchip_mmkv = /** @type {(inputs: Svchip_MmkvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MMKV`)
};

const pt_svchip_mmkv = /** @type {(inputs: Svchip_MmkvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MMKV`)
};

const zh_svchip_mmkv = /** @type {(inputs: Svchip_MmkvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MMKV`)
};

const tr_svchip_mmkv = /** @type {(inputs: Svchip_MmkvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MMKV`)
};

const ru_svchip_mmkv = /** @type {(inputs: Svchip_MmkvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MMKV`)
};

const pl_svchip_mmkv = /** @type {(inputs: Svchip_MmkvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MMKV`)
};

/**
* | output |
* | --- |
* | "MMKV" |
*
* @param {Svchip_MmkvInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_mmkv = /** @type {((inputs?: Svchip_MmkvInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_MmkvInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_mmkv(inputs)
	if (locale === "bn") return bn_svchip_mmkv(inputs)
	if (locale === "de") return de_svchip_mmkv(inputs)
	if (locale === "es") return es_svchip_mmkv(inputs)
	if (locale === "fr") return fr_svchip_mmkv(inputs)
	if (locale === "pt") return pt_svchip_mmkv(inputs)
	if (locale === "zh") return zh_svchip_mmkv(inputs)
	if (locale === "tr") return tr_svchip_mmkv(inputs)
	if (locale === "ru") return ru_svchip_mmkv(inputs)
	if (locale === "pl") return pl_svchip_mmkv(inputs)
	return en_svchip_mmkv(inputs)
});